module.exports = __webpack_public_path__ + "img/red.86ff2b4b.svg";